import {
  ACTIVITY_BUILDER_A4_LONG_SIDE,
  ACTIVITY_BUILDER_SETTINGS_WIDTH,
  SLIDE_HEIGHT_MINUS_HEADER_FOOTER,
} from '../activity-builder.constants';
import {
  PRESENT_DRAWER_WIDTH,
  PRESENT_SLIDE_ID,
  PresentDrawer,
} from './activity-builder-present.constants';

const PAGE_HEIGHT_INCLUDING_BANNER_AND_PADDING = 200;
const PAGE_HEIGHT_INCLUDING__PADDING = 120;

export function zoomContent({
  drawer,
  isMediaUpMd,
  hasBanner,
}: {
  drawer: PresentDrawer;
  isMediaUpMd: boolean;
  hasBanner: boolean;
}) {
  const el = document.getElementById(PRESENT_SLIDE_ID);
  if (!el) return;

  const menuWidth = drawer.isActive ? ACTIVITY_BUILDER_SETTINGS_WIDTH : 0;
  const menuDetailsWidth = isMediaUpMd
    ? drawer.isDetailActive
      ? PRESENT_DRAWER_WIDTH
      : 0
    : 0;

  const windowWidth = window.innerWidth - 80 - menuWidth - menuDetailsWidth;
  const windowHeight =
    window.innerHeight -
    (hasBanner
      ? PAGE_HEIGHT_INCLUDING_BANNER_AND_PADDING
      : PAGE_HEIGHT_INCLUDING__PADDING);
  const contentHeight = el.offsetHeight;

  const widthScale = windowWidth / ACTIVITY_BUILDER_A4_LONG_SIDE;
  const scaledHeight = widthScale * contentHeight;
  el.style.width = `${ACTIVITY_BUILDER_A4_LONG_SIDE}px`;
  el.style.height = `${SLIDE_HEIGHT_MINUS_HEADER_FOOTER}px`;

  if (scaledHeight > windowHeight) {
    el.style.transform = `scale(${windowHeight / contentHeight})`;
    el.style.margin = 'auto';
    el.style.transformOrigin = 'center top';
    if (el.parentElement) {
      el.parentElement.style.display = 'flex';
      el.parentElement.style.alignItems = 'center';
      el.parentElement.style.justifyContent = 'center';
    }
  } else {
    el.style.transform = `scale(${widthScale})`;
    el.style.margin = '0';
    el.style.transformOrigin = 'left top';
    if (el.parentElement) {
      el.parentElement.style.display = '';
      el.parentElement.style.alignItems = '';
      el.parentElement.style.justifyContent = '';
    }
  }
}

export function unZoomContent() {
  const el = document.getElementById(PRESENT_SLIDE_ID);
  if (el) {
    el.style.transform = '';
    el.style.transformOrigin = '';
    el.style.width = '';
    el.style.height = '';
    el.style.margin = '';
    if (el.parentElement) {
      el.parentElement.style.display = '';
      el.parentElement.style.alignItems = '';
      el.parentElement.style.justifyContent = '';
    }
  }
}

function getNextIds({
  windowSize,
  currentId,
  sectionIds,
}: {
  windowSize: number;
  currentId: string;
  sectionIds: string[];
}) {
  const currentIndex = sectionIds.indexOf(currentId);
  const start = Math.max(0, currentIndex - windowSize);
  const end = Math.min(sectionIds.length - 1, currentIndex + windowSize);
  const preload = [];
  for (let i = start; i <= end; i++) {
    preload.push(sectionIds[i]);
  }
  return preload;
}

export function getIdsToPreload({
  windowSize,
  currentId,
  sectionIds,
  queriedIds,
}: {
  windowSize: number;
  currentId: string;
  sectionIds: string[];
  queriedIds: string[];
}) {
  const ids = getNextIds({
    windowSize,
    sectionIds,
    currentId,
  });
  const nextIds = [];
  for (let i = 0; i < ids.length; i++) {
    if (!queriedIds.includes(ids[i])) {
      nextIds.push(ids[i]);
    }
  }
  return nextIds;
}
